<mat-drawer-container class="row nav-container">
  <mat-drawer #sidenav mode="side" opened (opened)="sidenaveState('opened')" (closed)="sidenaveState('closed')"
    class="side-nav-list">
    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a class="mb-1 nav-link"
          [ngClass] ="{'active': ix===0}"
          *ngFor="let name of fileMenu;let ix = index;"
          id="{{'v-pills'+ix}}"
          data-toggle="pill"
          href="{{'#doc'+ix}}" 
          role="tab"
         >
           {{name}}
        </a>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <p>
      <span *ngIf=" this.sidenavstate ==='opened'" (click)="sidenav.toggle()" class="material-icons arrow-sidenav">
        arrow_left
      </span>
      <span *ngIf=" this.sidenavstate ==='closed'" (click)="sidenav.toggle()" class="material-icons arrow-sidenav">
        arrow_right
      </span>
    </p>

    <div class="tab-content" id="v-pills-tabContent">
        <div class="tab-pane fade"
        *ngFor="let filepath of fileDetails;let i = index;"
        [ngClass] ="{'active': i ===0 ,'show':i ===0 }"
         id="{{'doc'+i}}" 
        role="tabpanel"
        >
          <iframe id="idIframe{{i+1}}" frameborder="0" 
            type="text/html" [src]="filepath|safeUrl" class="help-html" title="Help topics">
          </iframe>
        </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<div class="row">
  <div class="col-3"> </div>
  <div class="col-9"> </div>
</div>

<!-- <div class="row mt-3">
  <img src="../../../../../assets/ad1.png" width="100%">
</div> -->